<template>
  <div class="row justify-content-center m-0 mt-5">
      <div class="col-xl-6 text-center mt-5 mb-5">
        <h2 v-html="titulo"></h2>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Titulo2',
  props: {
    titulo: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-weight: 600;
  font-size: 30px;
}
</style>
